import script from "./ButtonNominate.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonNominate.vue?vue&type=script&setup=true&lang=js"

import "./ButtonNominate.vue?vue&type=style&index=0&id=40a144c5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a144c5"]])

export default __exports__